<template>
	<div class="relative grow flex items-center gap-3">
		<i class="fa-solid fa-spinner animate-spin"/>
		{{ trans('general.searching') }}
	</div>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
</script>